
import { defineComponent, PropType } from 'vue';
import { Option } from 'src/models/models';
export default defineComponent({
  name: 'SelectInput',
  props: {
    name: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    error: {
      type: Boolean,
      required: false,
      defautl: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: null
    },
    options: {
      type: Object as PropType<Option[]>,
      required: true
    }
  }
});
